import { render } from "./App.vue?vue&type=template&id=54605ad9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\phat_\\Local Sites\\mt-finance\\app\\public\\wp-content\\themes\\Divi-child\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__